module.exports = __webpack_public_path__ + "img/hongbao_kai@2x.c5c14eb6.png";